// extracted by mini-css-extract-plugin
export default {"itemShop":"ItemShop_itemShop__f3jrB","isDisabled":"ItemShop_isDisabled__JbDQI"};